import type { WidgetConfig } from '@digital-cs/shared';

/**
 * 把 widget 位置配置注入到 Shadow host 的 CSS 变量 + data 属性。
 * 仿 apply-theme 的 host.style.setProperty 套路:
 *  - --dcs-offset-x / --dcs-offset-y: 已带单位的 length(px 或 vw/vh),CSS 直接消费;
 *  - data-dcs-pos: 'left' | 'right',CSS 用 :host([data-dcs-pos='left']) 切换贴边方向。
 *
 * 单位换算在 JS 侧完成:percent → 水平 vw、垂直 vh(fixed 元素相对视口,
 * 比 CSS `%` 对 right/bottom 的相对维度语义更清晰)。clamp 上限(px≤512 / percent≤90)
 * 与 shared 校验一致,双保险防 offset 过大把 widget 推出视口。
 *
 * 作用域:web 线同时影响气泡(.dcs-web-bubble)与面板(.dcs-web-panel);
 * digital 线仅影响悬浮球(.dcs-mini-bubble),展开是 inset:0 全屏沉浸,不吃 offset。
 */
export function applyLayout(host: HTMLElement, cfg: WidgetConfig | null): void {
  if (!cfg) return;
  const isPercent = cfg.offsetUnit === 'percent';
  const max = isPercent ? 90 : 512;
  const clamp = (v: number): number => Math.max(0, Math.min(v, max));
  const ux = isPercent ? 'vw' : 'px';
  const uy = isPercent ? 'vh' : 'px';
  host.style.setProperty('--dcs-offset-x', `${clamp(cfg.offsetX)}${ux}`);
  host.style.setProperty('--dcs-offset-y', `${clamp(cfg.offsetY)}${uy}`);
  host.dataset.dcsPos = cfg.buttonPosition;
}
